import React, { useEffect, useState } from 'react';
import { Drawer, Table, Radio, Tooltip, Typography } from 'antd';
import { CRotationSkipProvider, CRate } from '../../domain/usdt-providers/cRotationSkipProvider';

const tail = (a: string) => (a && a.length > 14 ? '…' + a.slice(-10) : a);

// 近期 C 供能成功率報表(唯讀):清單 from/to/成功率/筆數,時間範圍可切換。scope 決定出款/歸集。
export function CSuccessRateDrawer(props: {
  scope: string;
  title?: string;
  visible: boolean;
  onClose: () => void;
}) {
  const { scope, title, visible, onClose } = props;
  const [hours, setHours] = useState(24);
  const [rows, setRows] = useState<CRate[]>([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const r = await CRotationSkipProvider.successRate(scope, hours);
      r.sort((a, b) => (a.rate ?? 1) - (b.rate ?? 1)); // 低成功率排前面
      setRows(r);
    } catch (e) {
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible) load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, hours]);

  return (
    <Drawer
      title={title ?? '近期 C 供能成功率'}
      width={640}
      visible={visible}
      onClose={onClose}
      destroyOnClose
    >
      <Radio.Group
        value={hours}
        onChange={(e) => setHours(e.target.value)}
        style={{ marginBottom: 12 }}
      >
        <Radio.Button value={24}>近 24h</Radio.Button>
        <Radio.Button value={72}>近 3 日</Radio.Button>
        <Radio.Button value={168}>近 7 日</Radio.Button>
      </Radio.Group>
      <Typography.Paragraph type="secondary" style={{ fontSize: 12 }}>
        低成功率排前面。「筆數」是該時間範圍內的 C 供能嘗試次數 —— 筆數太小(如 1、2)時成功率參考性低。
      </Typography.Paragraph>
      <Table
        rowKey={(r) => `${r.fromAddress}|${r.toAddress}`}
        loading={loading}
        size="small"
        pagination={false}
        dataSource={rows}
        columns={[
          {
            title: '錢包(from)',
            dataIndex: 'fromAddress',
            render: (v: string) => <Tooltip title={v}>{tail(v)}</Tooltip>,
          },
          {
            title: 'C 地址(to)',
            dataIndex: 'toAddress',
            render: (v: string) => <Tooltip title={v}>{tail(v)}</Tooltip>,
          },
          {
            title: '成功率',
            render: (_: any, r: CRate) => {
              const pct = r.total ? Math.round((r.rate ?? 0) * 100) : null;
              return pct == null ? (
                '—'
              ) : (
                <span style={{ color: pct < 50 ? '#cf1322' : '#3f8600' }}>{pct}%</span>
              );
            },
          },
          { title: '筆數', dataIndex: 'total', width: 80 },
        ]}
      />
    </Drawer>
  );
}
